import router from '@/router'

import SolFileAPIInstance from '@/api'

export default {
	logoutUser({commit}, payload) {
		if (localStorage.getItem('token')) {
			localStorage.removeItem('token')
		}
		router.push({path: '/login'})
		commit('authStatusChange', payload)
	},

	authStatusLogout({commit}, payload) {
		if (localStorage.getItem('token')) {
			localStorage.removeItem('token')
		}
		commit('authStatusLogout', payload)
	},

	async loginUser({ commit }, payload) {
		const result = await SolFileAPIInstance.authenticate({
			'email': payload.email,
			'password': payload.password
		})
		if (200 === result.status) {
			commit('authStatusChange', true);
			router.push('dashboard');
		} else {
			return new Error(result.data.message)
		}
	},

	getUsers({commit}, payload) {
		//api call here
		commit('getUsers', payload);
	}
}
